import * as API from "../API/index";
import { authorizedUser } from "components/Common/commonFunctions";

const createProductType = async (productTypeData) => {
  try {
    const res = await API.create_product_type(productTypeData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

const updateProductType = async (product_type_id, productTypeData) => {
  try {
    const res = await API.update_product_type(product_type_id, productTypeData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

const getProductTypeDetails = async (product_type_id) => {
  try {
    const res = await API.get_product_type_details(product_type_id);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

const getProductTypeList = async (
  pageNum,
  filters,
  searchString,
  sortField,
  sortOrder,
) => {
  try {
    const res = await API.product_type_list(
      pageNum,
      filters,
      searchString,
      sortField,
      sortOrder,
    );
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const deleteProductType = async (productTypeId) => {
  try {
    const res = await API.delete_product_type(productTypeId);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const getProductTypeListByPublisherID = async (publisherIDs) => {
  try {
    const publisherIDString = Array.isArray(publisherIDs)
      ? publisherIDs.join(",")
      : publisherIDs;
    const res = await API.product_type_list_by_publisher_id(publisherIDString);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export {
  createProductType,
  updateProductType,
  getProductTypeList,
  getProductTypeDetails,
};
